export enum LoadingStatus {
    NOT_STARTED,
    LOADING,
    DONE,
    ERROR
}